import { Icon, Typography } from "@/components/atoms";

export interface StepBreadcrumbProps {
  segments: string[];
}

/**
 * Static hint showing where in the Driver App a step is completed. Not the `Breadcrumbs` atom —
 * that one renders router `Link`s, and these segments point at screens in another app.
 */
export const StepBreadcrumb = ({ segments }: StepBreadcrumbProps) => (
  <div className="flex flex-wrap items-center text-neutral-silver-gray">
    {segments.map((segment, index) => (
      <div key={segment} className="flex items-center gap-2">
        {index > 0 && <Icon name="ArrowRight2" size={16} className="ml-1.5 shrink-0" />}
        <Typography variant="small-regular" className="!leading-4">
          {segment}
        </Typography>
      </div>
    ))}
  </div>
);
